import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function httpGetTransactions(payload) {
  const { data } = payload;
  const url = `${API_BASE_URL}/distinction/transactions`;

  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpGetVerifyTransaction(payload) {
  const { data } = payload;
  const url = `${API_BASE_URL}/distinction/transactions/verify`;

  return request({
    url,
    method: "get",
    data,
  });
}
